'use client';

import React from 'react';
import { ExperienceType } from '../types';
import { typography } from '@/design-system/tokens/typography';

interface ExperienceHighlightsProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceHighlights: React.FC<ExperienceHighlightsProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const getHighlights = () => {
    const exp = experience as {
      highlights?: string[];
      features?: string[];
      keyFeatures?: string[];
    };
    return exp?.highlights || exp?.features || exp?.keyFeatures || [];
  };

  const highlights = getHighlights();

  if (!Array.isArray(highlights) || highlights.length === 0) return null;

  return (
    <div className='space-y-4'>
      <h2
        className='font-semibold text-gray-900'
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        Highlights
      </h2>
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {highlights.map((highlight, index) => (
          <div
            key={index}
            className='flex flex-col items-center text-center p-4 bg-gray-50 rounded-lg'
          >
            <div className='w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center mb-2'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M16.667 5L7.5 14.167 3.333 10'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
            <p className='text-sm text-gray-700'>{highlight}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
